(function () {
  'use strict';
  var configNode = document.getElementById('IlikamBulkConfig');
  if (!configNode) throw new Error('Search pricing configuration is missing.');
  var config = JSON.parse(configNode.textContent);
  document.querySelectorAll('.ilikam-unit-search, .dT_ProductProactiveSearch').forEach(function (root, rootIndex) {
    root.classList.remove('dT_ProductProactiveSearch');
    root.classList.add('ilikam-unit-search');
    var input = root.querySelector('input[name="q"]');
    var results = root.querySelector('[data-unit-search-results]');
    if (!input || !results) throw new Error('Unit-price search markup is incomplete.');
    var panel = results.closest('.dT_PredictiveSearchResult_Section') || results;
    var controller;
    var timer;
    var sequence = 0;
    var selected = -1;
    results.id = 'UnitSearchResults-' + rootIndex;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    root.dataset.unitSearchReady = 'true';

    function close() {
      results.hidden = true;
      if (panel !== results) panel.style.display = 'none';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      selected = -1;
    }
    function options() { return Array.from(results.querySelectorAll('[data-unit-search-option]')); }
    async function search(query, current) {
      controller = new AbortController();
      var url = new URL(config.predictiveSearchUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', 'unit-price-predictive-search');
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (!preview && window.Shopify && Shopify.theme && Shopify.theme.role === 'unpublished') preview = Shopify.theme.id;
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        var response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Predictive search returned HTTP ' + response.status);
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var section = doc.getElementById('shopify-section-unit-price-predictive-search');
        if (!section) throw new Error('Predictive search section is missing.');
        if (current !== sequence) return;
        results.replaceChildren.apply(results, Array.from(section.childNodes));
        options().forEach(function (option, index) { option.id = results.id + '-option-' + index; });
        results.hidden = false;
        if (panel !== results) panel.style.display = 'block';
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name === 'AbortError' || current !== sequence) return;
        console.error('Unit-price search:', error);
        results.textContent = config.unitStrings.searchError;
        results.hidden = false;
        if (panel !== results) panel.style.display = 'block';
        input.setAttribute('aria-expanded', 'true');
      }
    }
    input.addEventListener('input', function () {
      sequence++;
      clearTimeout(timer);
      if (controller) controller.abort();
      close();
      results.replaceChildren();
      var query = input.value.trim();
      if (query.length < 2) return;
      var current = sequence;
      timer = setTimeout(function () { search(query, current); }, 200);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        sequence++; clearTimeout(timer); if (controller) controller.abort(); close(); return;
      }
      var entries = options();
      if (results.hidden || !entries.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        selected = selected < 0 ? (event.key === 'ArrowDown' ? 0 : entries.length - 1) :
          (selected + (event.key === 'ArrowDown' ? 1 : -1) + entries.length) % entries.length;
        entries.forEach(function (entry, index) {
          entry.classList.toggle('is-active', index === selected);
          entry.setAttribute('aria-selected', index === selected ? 'true' : 'false');
        });
        input.setAttribute('aria-activedescendant', entries[selected].id);
      } else if (event.key === 'Enter' && selected >= 0) {
        event.preventDefault();
        location.assign(entries[selected].querySelector('a').href);
      }
    });
    document.addEventListener('click', function (event) { if (!root.contains(event.target)) close(); });
  });
}());
